// src/app/core/http-error.interceptor.ts
import { Injectable, inject } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import * as Sentry from '@sentry/angular';
import { Auth } from '../services/auth';

@Injectable({
    providedIn: 'root'
  })
export class HttpErrorInterceptor implements HttpInterceptor {
  private auth = inject(Auth)

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        this.auth.getCurrentUserId().then(userId => {
          Sentry.setUser({
            id: userId || undefined
          });
        });

        if (error.status !== 401) {
          Sentry.captureException(error);
        }

        return throwError(() => error);
      })
    );
  }
}
